const listaDeMenus = (state) => {
    return state.items;
}

const menuSelecionado = (state) => {
    return state.menuSelecionado
}

export {
    listaDeMenus,
    menuSelecionado
}